import { ICustomEventDetail, IUserEventDetail, USER_CUSTOM_EVENT } from "@components/Context/SocketContext";
import { ChangeRackItemPos, ChangeUserColor, MinerAdminMiningEvent, MinerBaseEvent, MinerCustomerEvent, MinerDefaultSpeedEvent, MinerDropSpeedEvent, MinerHashEvent, MinerIdEvent, MinerLocationEvent, MinerPercentEvent, MinerPlanEvent, MinerSettingsEvent, MinerSettingsSpeedEvent, MinerSmoothEvent, MinerStartStopEvent, MinerTypeEvent, SocketEventTypes, SocketMessage, UserBaseEvent } from "./responses";
import { MinerChatMessage } from "../miners/dto";
// old fun, will remove soon
/*
function minerHashToChartEvent(
  id: number,
  event: MinerHashEvent
): ChartValueEvent {
  const result: ChartValueEvent = {
    id: id,
    miner_id: `${event.id}`, // если не приводить к строке, то вероятно график не будет обновляться
    pool_id: null,
    algo: null,
    is_total: null,
    value: event.speed,
    time: event.created,
  };
  return result;
}
function settingsSpeedToEvent(
  id: number,
  event: MinerSettingsSpeedEvent
): ChartValueEvent {
  const result: ChartValueEvent = {
    id: id,
    miner_id: null,
    pool_id: `${parseInt(event.id ?? "0")}`,
    algo: null,
    is_total: event.is_total,
    value: event.speed,
    time: event.created,
  };
  return result;
}

function algoSpeedToChartEvent(
  id: number,
  event: AlgoSpeedEvent
): ChartValueEvent {
  const result: ChartValueEvent = {
    id: id,
    miner_id: null,
    pool_id: null,
    is_total: event.is_total,
    algo: event.hash,
    value: event.speed,
    time: event.created,
  };
  return result;
}*/
// old end

// function isSubscribeEvent(messageEvent: any): messageEvent is SubscribeMessage {
//   try {
//     const event = JSON.parse(messageEvent) as SubscribeMessage;
//     if (event.action === SocketActions.Subscribe
//       || event.action === SocketActions.Unsubscribe) {
//       return true;
//     }
//     return false;
//   }
//   catch {
//     return false;
//   }
// }

function createCustomEvent(event: MinerBaseEvent<string | undefined>, type: SocketEventTypes) {
  const detail: ICustomEventDetail = {
    type,
    event,
  };
  return new CustomEvent(`miner-${event.id}`, {
    detail,
  });
}

function createUserEvent(event: UserBaseEvent, type: SocketEventTypes) {
  const detail: IUserEventDetail = {
    type,
    event,
  };
  return new CustomEvent(USER_CUSTOM_EVENT, {
    detail,
  });
}


function createEventForMiner(message: SocketMessage<any>) {
  let result: CustomEvent | null = null;
  switch (message.type) {


    // case SocketEventTypes.MINER_STATUS:
    //   result = createCustomEvent(
    //     message.event as MinerStatusEvent,
    //     SocketEventTypes.MINER_STATUS
    //   );
    //   break;

    case SocketEventTypes.SMT_MINER_CHAT:
      {
        const detail = message.event as MinerChatMessage
        document.dispatchEvent(
          new CustomEvent(`miner-${detail.MinerId}-chat`, {
            detail
          })
        );
      }
      break;
    // case SocketEventTypes.MINER_HASRATE: // old code, will remove soon
    //   {
    //     const detail = message.event as MinerHashEvent;
    //     document.dispatchEvent(
    //       new CustomEvent(`miner-chart-${detail.id}`, {
    //         detail: minerHashToChartEvent(message.id, detail),
    //       })
    //     );
    //   }
    //   break;


    // case SocketEventTypes.MINER_HASRATE: // oct: скорости для графиков и для MinerRow - через listener
    //   result = createCustomEvent(
    //     message.event as MinerHashEvent,
    //     SocketEventTypes.MINER_HASRATE
    //   );
    //   //onMinerHashrate(message.id, message.event as MinerHashEvent);
    //   break;

    case SocketEventTypes.MINER_ADMIN_START_STOP:
      result = createCustomEvent(
        message.event as MinerAdminMiningEvent,
        SocketEventTypes.MINER_ADMIN_START_STOP
      );
      // onMinerAdminStartStop(message.event as MinerAdminMiningEvent);
      break;

    case SocketEventTypes.MINER_START_STOP:
      result = createCustomEvent(
        message.event as MinerStartStopEvent,
        SocketEventTypes.MINER_START_STOP
      );
      //onMinerStartStop(message.event as MinerStartStopEvent);
      break;
    // Скорость по настройке для графика: oct: все скорости для графиков через listener!
    // case SocketEventTypes.MINER_SETTINGS_SPEED:
    //   result = createCustomEvent(
    //     message.event as MinerSettingsSpeedEvent,
    //     SocketEventTypes.MINER_SETTINGS_SPEED
    //   );
    //   break;
    //   case SocketEventTypes.MINER_SETTINGS_SPEED: oct: old version, will remove soon
    // {
    //   const detail = message.event as MinerSettingsSpeedEvent;
    //   document.dispatchEvent(
    //     new CustomEvent(`pool-chart-${detail.id}`, {
    //       detail: settingsSpeedToEvent(message.id, detail),
    //     })
    //   );
    // }
    // break;

    // Скорость по хешу для графика: oct: для графиков только listner-ы
    // case SocketEventTypes.MINER_HASH_SPEED:
    //   result = createCustomEvent(
    //     message.event as AlgoSpeedEvent,
    //     SocketEventTypes.MINER_HASH_SPEED
    //   );
    //   break;

    //   case SocketEventTypes.MINER_HASH_SPEED: // oct: old version, will remove soon
    // {
    //   const detail = message.event as AlgoSpeedEvent;
    //   document.dispatchEvent(
    //     new CustomEvent(`algo-chart-${detail.hash}`, {
    //       detail: algoSpeedToChartEvent(message.id, detail),
    //     })
    //   );
    // }
    // break;
    // Настройка майнера. Изменение miner ID:
    case SocketEventTypes.MINER_ID:
      result = createCustomEvent(
        message.event as MinerIdEvent,
        SocketEventTypes.MINER_ID
      );
      //onMinerId(message.event as MinerIdEvent);
      break;
    // Настройка майнера. Изменение типа:
    case SocketEventTypes.MINER_TYPE:
      result = createCustomEvent(
        message.event as MinerTypeEvent,
        SocketEventTypes.MINER_TYPE
      );
      //onMinerType(message.event as MinerTypeEvent);
      break;
    // Настройка майнера. Изменение default speed:
    case SocketEventTypes.MINER_DEFAULT_SPEED:
      result = createCustomEvent(
        message.event as MinerDefaultSpeedEvent,
        SocketEventTypes.MINER_DEFAULT_SPEED
      );
      //onMinerDefaultSpeed(message.event as MinerDefaultSpeedEvent);
      break;
    // Настройка майнера. Изменение drop speed:
    case SocketEventTypes.MINER_DROP_SPEED:
      result = createCustomEvent(
        message.event as MinerDropSpeedEvent,
        SocketEventTypes.MINER_DROP_SPEED
      );
      //onMinerDropSpeed(message.event as MinerDropSpeedEvent);
      break;
    // Настройка майнера. Изменение настройки:
    case SocketEventTypes.MINER_SETTINGS:
      result = createCustomEvent(
        message.event as MinerSettingsEvent,
        SocketEventTypes.MINER_SETTINGS
      );
      // onMinerSettings(message.event as MinerSettingsEvent);
      break;
    // Настройка майнера. Изменение кастомера:
    case SocketEventTypes.MINER_CUSTOMER:
      result = createCustomEvent(
        message.event as MinerCustomerEvent,
        SocketEventTypes.MINER_CUSTOMER
      );
      //onMinerCustomer(message.event as MinerCustomerEvent);
      break;
    // Настройка майнера. Изменение плана:
    case SocketEventTypes.MINER_PLAN:
      result = createCustomEvent(
        message.event as MinerPlanEvent,
        SocketEventTypes.MINER_PLAN
      );
      //onMinerPlan(message.event as MinerPlanEvent);
      break;
    // Настройка майнера. Изменение процентов:
    case SocketEventTypes.MINER_PERCENT:
      result = createCustomEvent(
        message.event as MinerPercentEvent,
        SocketEventTypes.MINER_PERCENT
      );
      //onMinerPercent(message.event as MinerPercentEvent);
      break;
    case SocketEventTypes.MINER_SMOOTH:
      result = createCustomEvent(
        message.event as MinerSmoothEvent,
        SocketEventTypes.MINER_SMOOTH
      );
      //onMinerSmooth(message.event as MinerSmoothEvent);
      break;

    case SocketEventTypes.RACK_ITEM_ADD:
      result = createCustomEvent(
        message.event as ChangeRackItemPos,
        SocketEventTypes.RACK_ITEM_ADD
      );
      break;

    case SocketEventTypes.CHANGE_USER_COLOR:
      result = createUserEvent(
        message.event as ChangeUserColor,
        SocketEventTypes.CHANGE_USER_COLOR
      );
      break;
    case SocketEventTypes.MINER_LOCATION:
      result = createCustomEvent(
        message.event as MinerLocationEvent,
        SocketEventTypes.MINER_LOCATION
      );
      //onMinerId(message.event as MinerIdEvent);
      break;
  }
  return result;
}

const SocketUtils = {
  //isSubscribeEvent,
  createCustomEvent,
  createUserEvent,
  createEventForMiner,
}

export default SocketUtils;